module.exports = __webpack_public_path__ + "img/abc.c829104f.png";